import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../Link/Link';
import Loader from '../../Common/Loader/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';

import uploadProfileImage from '../../../actions/siteadmin/uploadProfileImage'
import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';
import { api, profilePhotouploadDir } from '../../../config';
import { demoRestriction } from '../../../actions/demoRestriction';

import bt from '../../../components/commonStyle.css';
import s from './EditUserForm.css';


export class EditUserForm extends Component {
	constructor(props) {
		super(props)
		this.state = {
			countryCode: 'US',
			country: '+1',
		};
	}

	static defaultProps = {
		loading: false
	};

	success = async (file, fromServer) => {
		const { change, uploadProfileImage, id, picture, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('picture', fromServer && fromServer.fileName);
		uploadProfileImage(id, fromServer && fromServer.fileName, picture)
	}

	handleChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	}
	handleCountryChange = (e, selectedData) => {
		this.setState({
			country: selectedData.dialCode,
			countryCode: selectedData.countryCode
		});
	}
	componentDidMount() {
		const { initialValues } = this.props;
		if (initialValues?.country && initialValues?.phoneCountryCode) {
			this.setState({
				countryCode: initialValues?.phoneCountryCode,
				country: initialValues?.country
			});
		}
	}
	render() {
		const { handleSubmit, picture, loading, submitting, profilePictureLoader, currency, phoneDialCode } = this.props
		const { formatMessage } = this.props.intl;
		const permitBanOptions = [
			{ value: "0", label: formatMessage(messages.permit) },
			{ value: "1", label: formatMessage(messages.ban) }
		]
		const currencyOptions = currency && currency?.availableCurrencies?.filter(item => item?.isEnable).map(item => {
			return {
				value: item?.symbol,
				label: item?.symbol
			}
		})
		return (
			<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
				<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.editUser)}</h1>
				<div className={cx(bt.space4, s.singleCard)}>
					<div className={cx(s.profileImgSection)}>
						<label className={bt.commonLabelText} >{formatMessage(messages.profilePicture)}</label>
						<CommonImageDisplay loader={profilePictureLoader} imageSrc={picture ? api.apiEndpoint + profilePhotouploadDir + 'medium_' + picture : null} />
						<ImageUploadComponent
							className='commonSiteAdminDropzoneSpace'
							subText={formatMessage(messages.maximumUploadSizeLabel)}
							defaultMessage={formatMessage(messages.chooseFile)}
							componentConfig={{
								iconFiletypes: ['.jpg', '.png', '.svg'],
								multiple: false,
								showFiletypeIcon: false,
								postUrl: api.apiEndpoint + '/uploadProfileImage'
							}}
							success={this.success}
							loaderName={'profilePictureLoader'}
						/>
					</div>
				</div>
				<div className='twoColumnGrid'>
					<Field
						name="firstName"
						type="text"
						placeholder={formatMessage(messages.firstName)}
						component={InputFieldComponent}
						label={formatMessage(messages.firstName)}
						inputClass={bt.formControlInput}
					/>
					<Field
						name="lastName"
						type="text"
						placeholder={formatMessage(messages.lastName)}
						component={InputFieldComponent}
						label={formatMessage(messages.lastName)}
						inputClass={bt.formControlInput}
					/>

					<Field
						name="email"
						type="text"
						component={InputFieldComponent}
						placeholder={formatMessage(messages.email)}
						label={formatMessage(messages.email)}
						inputClass={bt.formControlInput}
						disabled={true}
					/>
					<Field
						name="phoneNumber"
						type="text"
						label={formatMessage(messages.phoneNumber)}
						placeholder={formatMessage(messages.phoneNumber)}
						component={InputFieldComponent}
						isAddon
						prefixLabel={phoneDialCode}
						disabled={true} />
					<Field
						name="isBan"
						component={SelectFieldComponent}
						label={formatMessage(messages.banStatus)}
						options={permitBanOptions}
						inputClass={bt.formControlSelect}
					/>

					<Field
						name='preferredCurrency'
						label={formatMessage(messages.preferredCurrency)}
						component={SelectFieldComponent}
						inputClass={bt.formControlSelect}
						options={currencyOptions}
					/>
				</div>
				<div className='commonButtonContainer'>
					<Link to={"/siteadmin/users"} className={bt.btnSecondary}>{formatMessage(messages.goBack)}</Link>
					<Loader
						type={"button"}
						label={formatMessage(messages.update)}
						show={loading}
						buttonType={'submit'}
						className={cx(bt.btnPrimary, 'loaderButtonFlex')}
						disabled={submitting || loading}
					/>
				</div>
			</Form>
		)
	}
}
EditUserForm = reduxForm({
	form: 'EditUserForm',
	validate,
	onSubmit: submit
})(EditUserForm)

const selector = formValueSelector('EditUserForm')

const mapState = state => ({
	id: selector(state, 'id'),
	picture: selector(state, 'picture'),
	phoneDialCode: selector(state, 'phoneDialCode'),
	loading: state?.loader?.EditUser,
	profilePictureLoader: state?.loader?.profilePictureLoader,
	currency: state.currency
})

const mapDispatch = {
	change,
	uploadProfileImage,
	demoRestriction
}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(EditUserForm)));


